{
  "modal": {
    "close": "Luk"
  },
  "toast": {
    "favoritesAdd": "Tilføjet til dine favoritter",
    "favoritesRemove": "Fjernet fra dine favoritter",
    "programAdd": "Tilføjet til dit program",
    "programRemove": "Fjernet fra dit program",
    "linkCopy": "Link kopieret",
    "linkCopyEmpty": "Der er ikke noget at kopiere",
    "linkCopyError": "Der skete desværre en fejl. Din browser understøtter det ikke."
  },
  "bookMeetings": {
    "placeholderDay": "Vælg dag",
    "placeholderTime": "Vælg tidspunkt",
    "placeholderNoAvailibleTimes": "Der er ingen ledige tider. Vælg en anden dag"
  },
  "choicesJs": {
    "loadingText": "Henter...",
    "noResultsText": "Der er ikke fundet nogen resultater",
    "noChoicesText": "Der er ikke noget at vælge imellem",
    "itemSelectText": "Klik for at vælge",
    "uniqueItemText": "Kun unikke værdier kan tilføjes",
    "customAddItemText": "Kun værdier, der matcher specifikke betingelser, kan tilføjes",
    "addItemText": "Tryk på Enten for at tilføje <b>$</b>",
    "maxItemText": "Kun $ kan tilføjes",
    "searchPlaceholderValue": "Skriv her for at søge"
  }
}
